export const CONSTANTS = {
    VALID_LOCALE_REG_EXP: /^[a-z]{2}-[a-z]{2}$/i,
    DEFAULT_LOCALE: 'en-us'
};
